








import CustomerAccountDetail from "@/components/partner/CustomerAccountDetail.vue";
import LayoutSimple from "@/layouts/LayoutSimple.vue";
import { handleError } from "@/lib/utility/handleError";
import PartnerFallbackMixin from "@/mixins/PartnerFallbackMixin.vue";
import { MrfiktivPartnerCustomerUserViewModelGen } from "@/services/mrfiktiv/v1/data-contracts";
import { BackendResourceEnum } from "@/store/enum/authResourceEnum";
import { CustomerAccountModule } from "@/store/modules/customer-account.store";
import { PartnerModule } from "@/store/modules/partner";
import { RefsMessagesModule } from "@/store/modules/refs.store";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";

@Component({
  components: {
    LayoutSimple,
    CustomerAccountDetail
  }
})
export default class CustomerAccountDetailView extends mixins(PartnerFallbackMixin) {
  isLoading = false;

  get customerAccountId() {
    return this.$route.params.customerAccountId;
  }

  get customerAccount() {
    return CustomerAccountModule.currentAccount;
  }

  get partnerId() {
    return PartnerModule.partner.id;
  }

  async mounted() {
    this.isLoading = true;
    await this.trySetByRouteOrDefault();

    let customer: MrfiktivPartnerCustomerUserViewModelGen | null = null;
    try {
      customer = await CustomerAccountModule.getOne({ partnerId: this.partnerId, id: this.customerAccountId });
    } catch (e) {
      handleError(e);
    } finally {
      this.isLoading = false;
    }
    if (customer) {
      await this.getUserMails(customer).catch(this.$log.error);
    }
  }

  async getUserMails(customer: MrfiktivPartnerCustomerUserViewModelGen) {
    if (!customer) {
      return;
    }
    const partnerId = PartnerModule.partner.id;
    await RefsMessagesModule.generateTimeLineMessagesForUser({
      ...customer,
      partnerId: partnerId,
      resource: BackendResourceEnum.CUSTOMER_DATA
    });
  }
}
